import { lazy } from 'react';

export const ConsignmentsViewPage = lazy(() => import('./ViewRecord/ViewRecord'));

export const ConsignmentsEditPage = lazy(() => import('./EditRecord/EditRecord'));

export const ConsignmentsAddPage = lazy(() => import('./AddRecord/AddRecord'));

export const ConsigmentsCirculationAddPage = lazy(
  () => import('./CirculationStatus/Add/CirculationStatusAdd')
);

export const ConsigmentsCirculationEditPage = lazy(
  () => import('./CirculationStatus/Edit/CirculationStatusEdit')
);
